import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import { isNotificationAllowed, isInvitationAllowed } from "common";
import { store } from "store";
var SponsorListItem = /** @class */ (function (_super) {
    tslib_1.__extends(SponsorListItem, _super);
    function SponsorListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.s = _this.sponsor;
        // TODO: use mixin instead?
        _this.isNotificationAllowed = isNotificationAllowed;
        _this.isInvitationAllowed = isInvitationAllowed;
        return _this;
    }
    SponsorListItem.prototype.dateDisplay = function (d) {
        if (!d)
            return "";
        return this.$d(new Date(d));
    };
    Object.defineProperty(SponsorListItem.prototype, "canSendBill", {
        get: function () {
            return store.selectedEvent.eventParticipant.canSendBill;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], SponsorListItem.prototype, "sponsor", void 0);
    SponsorListItem = tslib_1.__decorate([
        Component
    ], SponsorListItem);
    return SponsorListItem;
}(Vue));
export default SponsorListItem;
Vue.component('kk-sponsor-list-item', SponsorListItem);



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/SponsorListItem.vue
// module id = 53
// module chunks = 0